import { useState } from "react";
import {
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tooltip,
} from "@mui/material";
import {
  BsFillTrashFill,
  BsFillPencilFill,
  BsPlus,
  BsLink,
} from "react-icons/bs";
import CustomTextField from "../CustomTextField";
import { strings } from "../../utils/constants";

const PromotionItemsEditor = ({ items, itemsFr, onChange }) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    link: "",
  });
  const [formDataFr, setFormDataFr] = useState({
    title: "",
    description: "",
    link: "",
  });

  const handleOpenDialog = (index = null) => {
    if (index !== null) {
      setEditIndex(index);
      setFormData(items[index] || { title: "", description: "", link: "" });
      setFormDataFr(itemsFr[index] || { title: "", description: "", link: "" });
    } else {
      setEditIndex(null);
      setFormData({ title: "", description: "", link: "" });
      setFormDataFr({ title: "", description: "", link: "" });
    }
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setEditIndex(null);
  };

  const handleSave = () => {
    const enItem = { ...formData };
    const frItem = { ...formDataFr };
    
    if (editIndex !== null) {
      const newItems = [...items];
      const newItemsFr = [...itemsFr];
      newItems[editIndex] = enItem;
      newItemsFr[editIndex] = frItem;
      onChange(newItems, newItemsFr);
    } else {
      onChange([...items, enItem], [...itemsFr, frItem]);
    }
    handleCloseDialog();
  };

  const handleRemoveItem = (index) => {
    const newItems = items.filter((_, i) => i !== index);
    const newItemsFr = itemsFr.filter((_, i) => i !== index);
    onChange(newItems, newItemsFr);
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
          marginLeft: "5px",
          marginRight: "5px",
        }}
      >
        <h5 style={{ marginBottom: 0 }}>
          {strings.general.PROMOTION_ITEMS_ENGLISH}
        </h5>
        <Button
          variant="contained"
          onClick={() => handleOpenDialog()}
          style={{ backgroundColor: "#184437" }}
          startIcon={<BsPlus size={20} />}
        >
          {strings.general.ADD_NEW}
        </Button>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(350px, 1fr))",
          gap: "15px",
          marginLeft: "5px",
          marginRight: "5px",
        }}
      >
        {items.map((item, index) => {
          const itemFr = itemsFr[index] || {};
          return (
            <div
              key={index}
              style={{
                height: "220px",
                border: "1px solid #ddd",
                borderRadius: "4px",
                backgroundColor: "#fff",
                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                transition: "all 0.2s ease",
                padding: "14px",
                display: "flex",
                flexDirection: "column",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.15)";
                e.currentTarget.style.borderColor = "#184437";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.1)";
                e.currentTarget.style.borderColor = "#ddd";
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  marginBottom: "12px",
                }}
              >
                <Tooltip title={item.title} arrow placement="top">
                  <div
                    style={{
                      color: "#2c3e50",
                      fontWeight: "600",
                      fontSize: "15px",
                      fontFamily:
                        '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      flex: 1,
                      marginRight: "8px",
                      lineHeight: "1.4",
                    }}
                  >
                    {index + 1}. {item.title}
                  </div>
                </Tooltip>
                <div style={{ display: "flex", gap: "4px", flexShrink: 0 }}>
                  <IconButton
                    size="small"
                    onClick={() => handleOpenDialog(index)}
                    style={{ color: "#184437", padding: "4px" }}
                  >
                    <BsFillPencilFill size={13} />
                  </IconButton>
                  <IconButton
                    size="small"
                    onClick={() => handleRemoveItem(index)}
                    style={{ color: "#d32f2f", padding: "4px" }}
                  >
                    <BsFillTrashFill size={13} />
                  </IconButton>
                </div>
              </div>

              <Tooltip title={item.description} arrow placement="top">
                <div
                  style={{
                    color: "#5a6c7d",
                    fontSize: "13px",
                    lineHeight: "1.6",
                    fontFamily:
                      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "-webkit-box",
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: "vertical",
                    marginBottom: "14px",
                  }}
                >
                  {item.description}
                </div>
              </Tooltip>

              <div
                style={{
                  borderTop: "1px solid #e8eaed",
                  margin: "0 0 14px 0",
                }}
              />

              <Tooltip
                title={itemFr.title || "(French title not set)"}
                arrow
                placement="top"
              >
                <div
                  style={{
                    color: "#2c3e50",
                    fontWeight: "600",
                    fontSize: "15px",
                    fontFamily:
                      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    marginBottom: "8px",
                    lineHeight: "1.4",
                  }}
                >
                  {itemFr.title || "(French title not set)"}
                </div>
              </Tooltip>

              <Tooltip
                title={itemFr.description || ""}
                arrow
                placement="top"
              >
                <div
                  style={{
                    color: "#5a6c7d",
                    fontSize: "13px",
                    lineHeight: "1.6",
                    fontFamily:
                      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "-webkit-box",
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: "vertical",
                  }}
                >
                  {itemFr.description || ""}
                </div>
              </Tooltip>
            </div>
          );
        })}
      </div>

      {items.length === 0 && (
        <div
          style={{
            textAlign: "center",
            padding: "40px 20px",
            color: "#666",
            marginLeft: "5px",
            marginRight: "5px",
          }}
        >
          {strings.general.NO_RECORD_FOUND}
        </div>
      )}

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="md"
        fullWidth
        PaperProps={{
          style: {
            maxHeight: "none",
          },
        }}
      >
        <DialogTitle>
          {editIndex !== null ? strings.words.MODIFY : strings.general.ADD_NEW}
        </DialogTitle>
        <DialogContent
          style={{
            overflow: "visible",
            paddingBottom: "10px",
          }}
        >
          <CustomTextField
            style={{
              width: "100%",
              marginTop: "10px",
              marginBottom: "5px",
              marginLeft: "5px",
              marginRight: "5px",
            }}
            type="text"
            label={`${strings.general.PAGE_TITLE_ENGLISH}*`}
            variant="outlined"
            focusColor="#184437"
            value={formData.title}
            autoComplete="off"
            inputProps={{ maxLength: 150 }}
            onChange={(e) =>
              setFormData({ ...formData, title: e.target.value })
            }
          />
          <br />
          <CustomTextField
            style={{
              width: "100%",
              marginTop: "10px",
              marginBottom: "5px",
              marginLeft: "5px",
              marginRight: "5px",
            }}
            type="text"
            label={`${strings.words.DESCRIPTION} (${strings.words.ENGLISH})*`}
            variant="outlined"
            focusColor="#184437"
            value={formData.description}
            autoComplete="off"
            multiline
            rows={3}
            onChange={(e) =>
              setFormData({ ...formData, description: e.target.value })
            }
          />
          <br />
          <CustomTextField
            style={{
              width: "100%",
              marginTop: "10px",
              marginBottom: "5px",
              marginLeft: "5px",
              marginRight: "5px",
            }}
            type="text"
            label={`${strings.general.PAGE_TITLE_FRENCH}*`}
            variant="outlined"
            focusColor="#184437"
            value={formDataFr.title}
            autoComplete="off"
            inputProps={{ maxLength: 150 }}
            onChange={(e) =>
              setFormDataFr({ ...formDataFr, title: e.target.value })
            }
          />
          <br />
          <CustomTextField
            style={{
              width: "100%",
              marginTop: "10px",
              marginBottom: "5px",
              marginLeft: "5px",
              marginRight: "5px",
            }}
            type="text"
            label={`${strings.words.DESCRIPTION} (${strings.words.FRENCH})*`}
            variant="outlined"
            focusColor="#184437"
            value={formDataFr.description}
            autoComplete="off"
            multiline
            rows={3}
            onChange={(e) =>
              setFormDataFr({ ...formDataFr, description: e.target.value })
            }
          />
          <br />
          <CustomTextField
            style={{
              width: "100%",
              marginTop: "10px",
              marginBottom: "5px",
              marginLeft: "5px",
              marginRight: "5px",
            }}
            type="text"
            label={`${strings.general.LINK} (${strings.words.ENGLISH})`}
            variant="outlined"
            focusColor="#184437"
            value={formData.link}
            autoComplete="off"
            inputProps={{ maxLength: 500 }}
            onChange={(e) =>
              setFormData({ ...formData, link: e.target.value })
            }
          />
          <br />
          <CustomTextField
            style={{
              width: "100%",
              marginTop: "10px",
              marginBottom: "5px",
              marginLeft: "5px",
              marginRight: "5px",
            }}
            type="text"
            label={`${strings.general.LINK} (${strings.words.FRENCH})`}
            variant="outlined"
            focusColor="#184437"
            value={formDataFr.link}
            autoComplete="off"
            inputProps={{ maxLength: 500 }}
            onChange={(e) =>
              setFormDataFr({ ...formDataFr, link: e.target.value })
            }
          />
        </DialogContent>
        <DialogActions style={{ padding: "20px" }}>
          <Button
            variant="contained"
            color="primary"
            style={{
              backgroundColor: "#184437",
              marginRight: "12px",
            }}
            onClick={handleSave}
          >
            {strings.words.SAVE}
          </Button>
          <Button
            variant="contained"
            color="primary"
            style={{ backgroundColor: "#184437" }}
            onClick={handleCloseDialog}
          >
            {strings.words.CANCEL}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default PromotionItemsEditor;
